import { MessageDescriptor } from 'react-intl';

import { logWarning } from '@savgroup-front-common/configuration/appInsights/AppInsights';

import { intl } from '../helpers/intl';
import { collectMissingDynamicTerm } from '../services/dynamicTermSuggestion/dynamicTermSuggestionStore';

export type IntlMessageConfig = {
  id: string;
  values?: Record<string, string>;
  basePath: string;
  fallback?: string;
};

export function isIntlMessageConfig(
  value: unknown,
): value is IntlMessageConfig {
  return typeof value === 'object' && value !== null;
}

export function safeFormattedIntlStringWithId(
  idOrConfig?: string | IntlMessageConfig,
  valuesParam?: Record<string, string>,
): string {
  const { id, values, basePath, fallback } = isIntlMessageConfig(idOrConfig)
    ? idOrConfig
    : {
        id: idOrConfig,
        values: valuesParam,
        basePath: undefined,
        fallback: undefined,
      };

  if (!id) {
    return '';
  }

  const fullMessageId = [basePath, id].filter((part) => !!part).join('');
  const isMessageExist = !intl || !!intl.messages[fullMessageId];

  if (!isMessageExist) {
    logWarning(
      `[PO-EDITOR]: message "${fullMessageId}" does not have a corresponding message in Dynamic messages.`,
    );

    collectMissingDynamicTerm({ messageId: fullMessageId });

    if (fallback) {
      return fallback;
    }
  }

  const messageId = isMessageExist ? fullMessageId : id;
  const message = { id: messageId, defaultMessage: messageId };

  return intl?.formatMessage(message as MessageDescriptor, values) as string;
}
